import _ from 'lodash'

// const cardPrepare = (c)=>{ return _.find(c, {'@method':'prepare'}) }
// const cardMix = (c)=>{ return _.find(c, {'@method':'mix'}) }
const cardEnableDiceBattle = (c)=>{ return _.find(c, {'@method':'init-battle'}) }
const cardInitBattle = (c)=>{ return _.find(c, {'@method':'init-battle'}) }
const cardAi = (c)=>{ return _.find(c, {'@method':'ai'}) }
const cardInput = (c)=>{ return _.find(c, {'@method':'input'}) }
const cardStartAction = (c)=>{ return _.find(c, {'@method':'start-action'}) }
const cardAction = (c)=>{ return _.find(c, {'@method':'action'}) }

const cardList = (master) => {
  let list = {}
  master.forEach((v)=>{
    let e = _.find(v, { '@method':'info', args:{type:'buff'} })
    if(e){
      let i = _.find(v, { '@method':'init' })
      list[i.args.key] = e.args.name
    }
  })
  return list
}

const command = {
  'status.temp-add' (arg) {
    const comp = _.template('<p>・<%- status %>が<%- value %></p>')
    return comp(arg)
  },

  //init-battle
  'passive.standby' () { return '<p>初期選択</p>' },

  //targeting
  'targeting.load-live-enemy' () { return '・敵' },
  'targeting.load-live-friend' () { return '・味方' },
  'targeting.load-me' () { return '・自己' },
  'targeting.without-me' () { return '＆自分以外' },
  'targeting.focus-me' () { return '＆自分狙い' },
  'targeting.serious' (arg) { 
    const comp = _.template('＆HP<%- HP/10 %>%以下')
    return comp(arg)
  },
  'targeting.equip-buff' (arg, list) {
    const color = {
      'r':'赤', 'b':'青', 'y':'黄', 'a':'無',
      's':'茶', 'g':'緑', 'd':'黒', 'w':'白',
    } 
    const type = {
      'buff-magic':'強化魔法', 'debuff-magic':'弱体魔法',
      'buff-physical':'強化肉体', 'debuff-physical':'弱体肉体',
      'buff-mental':'強化精神', 'debuff-mental':'弱体精神',
      'buff-stance':'強化体勢', 'debuff-stance':'弱体体勢',
    }
    const comp = _.template('＆<%- buffName %><%- buffColor %><%- buffType %>状態付与')
    return comp({
      buffName: list[arg.buffCommand],
      buffColor: color[arg.buffColor], 
      buffType: type[arg.buffType]
    })
  },
  'targeting.unequip-buff' (arg, list) {
    const color = {
      'r':'赤', 'b':'青', 'y':'黄', 'a':'無',
      's':'茶', 'g':'緑', 'd':'黒', 'w':'白',
    } 
    const type = {
      'buff-magic':'強化魔法', 'debuff-magic':'弱体魔法',
      'buff-physical':'強化肉体', 'debuff-physical':'弱体肉体',
      'buff-mental':'強化精神', 'debuff-mental':'弱体精神',
      'buff-stance':'強化体勢', 'debuff-stance':'弱体体勢',
    }
    const comp = _.template('＆<%- buffName %><%- buffColor %><%- buffType %>状態未付与')
    return comp({
      buffName: list[arg.buffCommand],
      buffColor: color[arg.buffColor], 
      buffType: type[arg.buffType]
    })
  },

  //ai
  'ai.targeting' () { return '' },
  'ai.change' () { return '' },
  'ai.exists' () { return '' },
  'ai.turnCount' (arg) {
    const opr = {
      'eq-more': '以後',
      'eq-less': '以内',
      'every': '毎',
      'eq': '目'
    }
    const comp = _.template('・<%= count %>T<%= opr %>')
    return comp({
      count: arg.turnCount,
      opr: opr[arg.turnOperator]
    })
  },
  'ai.0-time' () { return '' },
  'ai.cost' () { return '' },

  //input
  'character.count-skill-ai' () { return '' },

  //start-action
  'passive.avoid' (arg) {
    const comp = _.template('<p>回避状態</p>')
    return comp(arg)
  },
  'passive.guard' (arg) {
    const comp = _.template('<p>防御状態</p>')
    return comp(arg)
  },

  //action
  'character.base-action' () { return '' },
  'free/show.skill-performance' () { return '' },
  'dice.throw' () { return '<p>・ダイス２個使用</p>' },
  'free/attack.magical-attack' (arg, list) {
    let text = ''
    //TODO 種別
    const comp = _.template('魔法攻撃(威力x<%- INTRatio %>+<%- ADamage %>/CTx<%- criticalDamageRatio %>')
    text += comp(arg)
    if(arg.rangeAttack){
      text += '/範囲+'+arg.rangeAttack
    }
    if(arg.chainAttack){
      text += ')x'+(arg.chainAttack+1)
    }else{
      text += ')'
    }
    //TODO onHit
    if(arg.onHit){
      _.map(arg.onHit, (v)=>{
        text += '⇒'
        text += command[v['@call']](v['arguments'], list)
      })
    }
    return text
  },
  'free/attack.physical-attack' (arg, list) {
    let text = ''
    //TODO 種別
    const comp = _.template('物理攻撃(威力x<%- STRRatio %>+<%- ADamage %>/CTx<%- criticalDamageRatio %>')
    text += comp(arg)
    if(arg.rangeAttack){
      text += '/範囲+'+arg.rangeAttack
    }
    if(arg.chainAttack){
      text += ')x'+(arg.chainAttack+1)
    }else{
      text += ')'
    }
    //TODO onHit
    if(arg.onHit){
      _.map(arg.onHit, (v)=>{
        text += '⇒'
        text += command[v['@call']](v['arguments'], list)
      })
    }
    return text
  },
  'free/buff.add' (arg, list) {
    const comp = _.template('「<%- name %>」付与')
    return comp({ name: list[arg.buff] })
  },
  'free/buff.add-power' (arg, list) {
    const color = {
      'r':'赤', 'b':'青', 'y':'黄', 'a':'無',
      's':'茶', 'g':'緑', 'd':'黒', 'w':'白',
    } 
    const type = {
      'buff-magic':'強化魔法', 'debuff-magic':'弱体魔法',
      'buff-physical':'強化肉体', 'debuff-physical':'弱体肉体',
      'buff-mental':'強化精神', 'debuff-mental':'弱体精神',
      'buff-stance':'強化体勢', 'debuff-stance':'弱体体勢',
    }
    let power = '無変化'
    if(arg.power > 0){
      power = arg.power + '強化'
    }else if(arg.power < 0){
      power = -arg.power + '弱体'
    }
    const comp = _.template('<%- buffName %><%- buffColor %><%- buffType %>状態<%- power %>')
    return comp({
      buffName: list[arg.command],
      buffColor: color[arg.color], 
      buffType: type[arg.type],
      power
    })
  },
  'free/heal.normal-heal' (arg) {
    let text = ''
    const comp = _.template('回復(効果量x<%- MNDRatio %>+<%- AHeal %>/VITx<%- VITRatio %>)')
    text += comp(arg)
    return text
  },

  //call
  'base-targeting-cmd.init' () { return '' },
  'base-targeting-cmd.ai' () { return '' },
  'base-targeting-cmd.input' () { return '' },
  'base-targeting-cmd.start-action' (arg) {
    //TODO Armor
    if(arg.Aria < 100){
      return '<p>詠唱時間：即時</p>'
    }else if(arg.Aria <= 750){
      return '<p>詠唱時間：短</p>'
    }else if(arg.Aria <= 1250){
      return '<p>詠唱時間：並</p>'
    }else if(arg.Aria < 2000){
      return '<p>詠唱時間：長</p>'
    }else{
      return '<p>詠唱時間：超長</p>'
    }
  }
}

const buildCommand = (c, list)=>{
  let text = ''
  if(c.hook){
    _.map(c.hook, (v)=>{ 
      text += command[v](c.args, list)
    })
  }
  if(c.call){
    text += command[c.call](c.args, list)
  }else if(c.code){
    _.map(c.code, (v)=>{
      text += '<p>・'
      text += command[v['@call']](v['arguments'], list)
      text += '</p>'
    })
  }
  return text
}

const build = (card, _list)=>{
  const list = cardList(_list)

  let text = ''

  //合成

  //準備

  //ダイス専用効果
  if(cardEnableDiceBattle(card)){
    text += '<p><strong>【ダイスバトル専用効果】</strong></p>'
    //初期化
    text += buildCommand(cardInitBattle(card), list)
    //発動条件
    text += '<p><span class="ql-size-small">＜発動条件＞</span></p>'
    text += buildCommand(cardAi(card), list)
    //発動対象
    text += '<p><span class="ql-size-small">＜発動対象＞</span></p>'
    text += '<p>'
    text += buildCommand(cardInput(card), list)
    text += '</p>'
    //詠唱
    text += '<p><span class="ql-size-small">＜詠唱＞</span></p>'
    text += buildCommand(cardStartAction(card), list)
    //発動効果
    text += '<p><span class="ql-size-small">＜発動効果＞</span></p>'
    text += buildCommand(cardAction(card), list)
  }

  return text
}

export default {
  build
}
